import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import { DocumentView } from "../../components/view-form-components/image.view";
import ViewLocationMap from "../../components/view-form-components/location-view";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import ShareModal from "../modal/share-modal";
import SubmitModal from "../modal/submit-modal";
import errorToast from "../toast/errorToast";

const ViewLeadComponent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.lead;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);
  const [submitModal, setsubmitModal] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/lead/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/lead/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/lead/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const convertToCustomerFnc = (id) => {
    api
      .post(`/lead/convert-to-customer`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/lead/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        errorToast(err?.response?.data?.message || "Delete failed");
        setLoading(false);
      });
  };

  const writePermission = (row) => {
    if (row?.assignedTo) {
      if (row?.assignedTo.write == true) {
        return true;
      }
      return false;
    }
    if (permission?.write == true) {
      return true;
    }
  };

  return (
    <section className="relative">
      <SubmitModal
        isOpen={submitModal}
        onClose={() => setsubmitModal(false)}
        btnFnc={() => convertToCustomerFnc(params?.id)}
        title={"Are you sure you want to convert"}
        btnName="Convert"
      />
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="lead"
        modulelabel="lead"
      />
      <section className="overflow-auto px-3">
        <div className="flex md:flex-row flex-col-reverse justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">Lead - view</h2>
          <div className="flex gap-3 items-center justify-start overflow-auto text-nowrap w-full max-w-[450px]">
            {writePermission(data) && (
              <button
                onClick={() => setsubmitModal(true)}
                type="button"
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                Convert to customer
              </button>
            )}

            {writePermission(data) && (
              <button
                type="button"
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {writePermission(data) && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/lead/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {writePermission(data) && (
              <button
                type="button"
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Name"} value={data?.name ?? "--"} />
            <TextView label={"address"} value={data?.address ?? "--"} />
            <TextView label={"state"} value={data?.state?.name ?? "--"} />
            <TextView label={"city"} value={data?.city?.name ?? "--"} />
            <DocumentView
              label={"visiting card photo"}
              value={data?.visiting_card_photo}
            />
            <DocumentView
              label={"outside place photo"}
              value={data?.outside_place_photo}
            />
            <TextView
              label={"contact name"}
              value={data?.contact_name ?? "--"}
            />
            <TextView
              label={"contact number"}
              value={data?.contact_number ?? "--"}
            />
            <TextView
              label={"type of client"}
              value={data?.type_of_client ?? "--"}
            />
            <TextView
              label={"price agreed upon"}
              value={data?.price_agreed_upon ?? "--"}
            />
            <TextView
              label={"price agreed upon"}
              value={data?.price_agreed_upon ?? "--"}
            />
            <TextView
              label={"last_visited"}
              value={data?.last_visited ?? "--"}
            />
            <TextView label={"last_called"} value={data?.last_called ?? "--"} />
            <TextView
              label={"next_visit_on"}
              value={data?.next_visit_on ?? "--"}
            />
            <TextView
              label={"type_of_billing"}
              value={data?.type_of_billing ?? "--"}
            />
            <TextView label={"status"} value={data?.status ?? "--"} />
            <TextView
              label={"created_by"}
              value={data?.createdBy?.name ?? "--"}
            />
            <ViewLocationMap
              label={"location"}
              lat={data?.location?.lat ?? ""}
              lng={data?.location.lng ?? ""}
            />
          </div>
        </section>
      </section>
    </section>
  );
};

export default ViewLeadComponent;
